import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml'];

export const modalFormSchema = z.object({
  name: z.string().min(1, t('pages.application_teams.components.teams_edit_modal.schema.required')),
  acronym: z.string().min(1, t('pages.application_teams.components.teams_edit_modal.schema.required')),
  is_favorite: z.boolean().optional(),
  file: z
    .any()
    .refine(
      file => (file && ACCEPTED_IMAGE_TYPES.includes(file.type)) || !file,
      t('pages.application_teams.components.teams_edit_modal.schema.required_file'),
    ),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
